import { createSelector } from '@reduxjs/toolkit';
import { addDays, startOfToday } from 'date-fns';
import { selectDatesValue } from './selectDatesValue';
import { selectDatesLabel } from './selectDatesLabel';

const today = startOfToday();

export const selectDatesFilter = createSelector([selectDatesValue, selectDatesLabel], (value, label) => ({
  value,
  label,
  min: today,
  max: addDays(today, 365),
}));
